import styled from 'styled-components';

import {
  SharePublicLink,
  SharePublicLinkLeft
} from '@hero/components/organisms/Share/SharePublicLink/style';
import { DEVICE } from '@hero/constants';

const ShareWrapper = styled.div`
  display: flex;
  gap: 24px;
  justify-content: space-between;

  ${DEVICE.tablet.max} {
    flex-direction: column;
  }
`;

const ShareLeft = styled.div`
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--radius-m);
  display: flex;
  flex: 1;
  flex-direction: column;
  height: fit-content;
  padding: 16px;
  width: 100%;
`;

const ShareHeader = styled.div`
  align-items: center;
  border-bottom: 1px solid var(--color-accent-secondary-weaker);
  display: flex;
  justify-content: space-between;
  padding-bottom: 16px;
`;

const ShareBody = styled.div``;

const ShareTableRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  margin-top: 8px;
`;

const ShareSection = styled.div`
  ${({ hasBorderBottom }) => {
    return hasBorderBottom && 'border-bottom: 1px solid var(--color-accent-secondary-weaker);';
  }}
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 0;

  ${SharePublicLink} {
    border: none;
  }

  ${SharePublicLinkLeft} {
    padding: var(--size-16) 0;
  }
`;

const SupportLink = styled.a`
  color: var(--color-fg-default) !important;
  text-decoration: underline;
`;

export {
  ButtonGroup,
  ShareBody,
  ShareHeader,
  ShareLeft,
  ShareSection,
  ShareTableRow,
  ShareWrapper,
  SupportLink
};
